module.exports = require("./dist/select.js");
require("./dist/select.css");


//////////////////
// WEBPACK FOOTER
// angular-ui-select (bower component)
// module id = 369
// module chunks = 1